import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core";
import sol from "./assets/Sol.png";
import luna from "./assets/luna.png";
import nublado from "./assets/nublado.png";
import lunanube from "./assets/lunanube.png";
import nube from "./assets/nube.png";
import nubes from "./assets/nubes.png";
import ImageComponent from "./ImageComponent";

const useTooltipStyles = makeStyles({
  tooltip: {
    position: "relative",
    display: "inline-block",
    "&:hover $tooltipText": {
      visibility: "visible",
      opacity: 1,
    },
  },
  tooltipText: {
    visibility: "hidden",
    width: "120px",
    backgroundColor: "#fff",
    color: "#000",
    textAlign: "center",
    borderRadius: "6px",
    padding: "5px 0",
    position: "absolute",
    zIndex: 1,
    top: "85%",
    left: "50%",
    marginLeft: "-60px",
    opacity: 0,
    transition: "opacity 0.3s",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: "100%",
      left: "50%",
      marginLeft: "-5px",
      borderWidth: "5px",
      borderStyle: "solid",
      borderColor: "transparent transparent white transparent",
    },
  },
});

const iconMapping = {
  sol_despejado: { image: sol, text: "Despejado" },
  luna_despejado: { image: luna, text: "Despejado" },
  sol_semi_nublado: { image: nublado, text: "Semi nublado" },
  luna_semi_nublado: { image: lunanube, text: "Semi nublado" },
  nube: { image: nube, text: "Nublado" },
  dos_nubes: { image: nubes, text: "Mayormente nublado" }
};

const GetWeatherIcon = ({ iconoNubosidad }) => {
  const classes = useTooltipStyles();
  const iconData = iconMapping[iconoNubosidad] || { image: sol, text: "sin información" };

  return (
    <div className={classes.tooltip}>
      <ImageComponent src={iconData.image} />
      <span className={classes.tooltipText}>{iconData.text}</span>
    </div>
  );
};

GetWeatherIcon.propTypes = {
  iconoNubosidad: PropTypes.string.isRequired,
};

export default GetWeatherIcon;
